import React from 'react';
import t from '@guestyci/localize/t.macro';
import { Button, Text, Heading, Stack } from '@guestyci/arc';
import { Asterisk, MessageSquareText, Mail } from '@guestyci/icons/system';
import { utils } from 'utils';

const MFA_OPTIONS = [
  {
    key: 'googleAuthenticator',
    icon: Asterisk,
    title: () => t('Google authenticator'),
    description: () => t('Secure login with the Google Authenticator app'),
    buttonLabel: () => t('Set up Google Authenticator'),
  },
  {
    key: 'sms',
    icon: MessageSquareText,
    title: () => t('SMS authentication'),
    description: () => t('Receive verification codes via text message'),
    buttonLabel: () => t('Use SMS verification'),
  },
  {
    key: 'email',
    icon: Mail,
    title: () => t('Email authentication'),
    description: () => t('Get verification codes sent to your email'),
    buttonLabel: () => t('Use email verification'),
  },
];

const MfaOptionCard = ({ icon: Icon, title, description, buttonLabel, onSelect }) => (
  <Stack spacing={3} direction="row" align="start" className="gst-w-full">
    <div className="gst-flex gst-items-center gst-justify-center gst-rounded-full gst-bg-information-foreground gst-w-12 gst-h-12 gst-shrink-0">
      <Icon className="gst-size-6" aria-hidden="true" />
    </div>
    <Stack spacing={3} direction="column" className="gst-flex-1 gst-min-w-0">
      <Stack spacing={1} direction="column">
        <Text size="base">{title()}</Text>
        <Text type="secondary" size="sm">{description()}</Text>
      </Stack>
      <Button
        variant="secondary"
        className="gst-w-full"
        onClick={onSelect}
      >
        {buttonLabel()}
      </Button>
    </Stack>
  </Stack>
);

const CustomMFA = ({ mfaConfig }) => {
  const logEvent = utils.eventsLogger?.unifiedLoginDio?.track;

  const visibleOptions = MFA_OPTIONS.filter((option) => mfaConfig?.[option.key]?.available);

  const handleOptionSelect = (optionKey) => {
    if (logEvent) {
      logEvent('registration_MFA', 'click', { method: optionKey });
    }
    mfaConfig?.[optionKey]?.onSelect?.();
  };

  if (!mfaConfig) return null;

  return (
    <Stack spacing={6} direction="column" className="gst-w-full">
      <Stack spacing={2} direction="column">
        <Heading variant="h2">{t('Set up multi-factor authentication')}</Heading>
        <Text type="secondary" size="sm">
          {t('Choose an authentication method to protect your account.')}
        </Text>
      </Stack>

      <Stack spacing={7} direction="column">
        {visibleOptions.map((option) => (
          <MfaOptionCard
            key={option.key}
            icon={option.icon}
            title={option.title}
            description={option.description}
            buttonLabel={option.buttonLabel}
            onSelect={() => handleOptionSelect(option.key)}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default CustomMFA;
